var oneHundredAndTwentyYearsOld = new Date(
  new Date().setFullYear(new Date().getFullYear() - 120)
);

var sixteenYearsOld = new Date(
  new Date().setFullYear(new Date().getFullYear() - 16)
);

export const validateMembersDateOfBirth = dateOfBirth => {
  return (
    dateOfBirth >= oneHundredAndTwentyYearsOld && dateOfBirth <= sixteenYearsOld
  );
};

